import { ArticleDetailProps } from './ArticleDetailProps.tsx';
import { getKeys } from '../../../../_helpers/keyboard.ts';
import { joinString } from '../../../../_helpers/join-string.ts';

import './ArticleDetail.scss';
import { sendDataLinkEvent } from '../_helpers/dataLinkEventHelper.ts';

export const ArticleDetail = (props: ArticleDetailProps) => {
	const isArticleDetailVisible =
		props.publicationDate || !!props.authors.length;
	const isSeparatorVisible = props.publicationDate && !!props.authors.length;

	const Author = ({
		link,
		dataLinkEvent,
		children,
	}: {
		link: string;
		dataLinkEvent: string;
		children: string;
	}) => {
		const onKeyDown = (event: React.KeyboardEvent) => {
			const keys = getKeys(event);
			if (keys.isEnter || keys.isSpace) {
				event.stopPropagation();
			}
		};

		const onClick = (event: React.MouseEvent) => {
			event.stopPropagation();
			sendDataLinkEvent(dataLinkEvent);
		};

		return link ? (
			<a
				data-final-url
				className="author"
				href={link}
				target="_parent"
				onClick={onClick}
				onKeyDown={onKeyDown}
			>
				{children}
			</a>
		) : (
			<strong className="author">{children}</strong>
		);
	};

	return (
		isArticleDetailVisible && (
			<div className={joinString(['blk-ac-article-detail', props.className])}>
				{props.publicationDate && (
					<span className="publication-date">{props.publicationDate}</span>
				)}

				{isSeparatorVisible && <span className="separator">|</span>}

				{!!props.authors.length && (
					<>
						<span className="written-by-label">
							{props.writtenByTranslation}
						</span>
						{props.authors.map((author, index) => (
							<Author
								key={index}
								// eslint-disable-next-line @typescript-eslint/ban-ts-comment
								// @ts-ignore
								link={author.authorPageLink}
								// eslint-disable-next-line @typescript-eslint/ban-ts-comment
								// @ts-ignore
								dataLinkEvent={author.dataLinkEvent}
							>
								{author.authorName}
							</Author>
						))}
					</>
				)}
			</div>
		)
	);
};

ArticleDetail.defaultProps = {
	authors: [],
	publicationDate: '',
	writtenByTranslation: 'By',
};
